module.exports = __webpack_public_path__ + "img/home1.7ba54635.png";